import { useState } from "react"

import { useGetScanHistoryStatistics } from "@/api/useScanHistory"
import { useTranslation } from "@/hooks/useTranslation"
import { Widget } from "@/molecules/Widget"
import { TopInitiatorsDropdown } from "./TopInitiatorsDropdown"
import { TopInitiatorsTable } from "./TopInitiatorsTable"

import type { Filters } from "./TopInitiatorWidget.types"

export const TopInitiatorWidget = () => {
  const { isLoading } = useGetScanHistoryStatistics()
  const [filters, setFilters] = useState<Filters>(["failed", "PR"])
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.scanHistory.topInitiators"
  })

  return (
    <Widget
      loading={isLoading}
      title={t("title")}
      popover={{ content: t("tooltip") }}
      aside={
        <TopInitiatorsDropdown
          filters={filters}
          setFilters={setFilters}
          t={t}
        />
      }
    >
      <TopInitiatorsTable filters={filters} />
    </Widget>
  )
}
